import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router} from "react-router-dom";

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Router>
    {/* <React.StrictMode> */}
      <Provider store={store}>
          <App />
      </Provider>
    {/* </React.StrictMode> */}
  </Router>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
